import { compose } from 'recompose';

import { withTranslation } from 'react-i18next';
import AttachFilesModal from './attachFilesModal';

const enhance = compose(
  withTranslation(['chat', 'common']),
);
export default enhance(AttachFilesModal);
